import React from 'react'
import "./InitialImgStyles.css"
import Cara from "../assets/Cara-nobg.png"

const InitialImg = () => {
  return (
    <div className='hero'>
      <p className='eyebrow'>Joaquín Gallardo — Desarrollo Full-Stack</p>

      <div className='hero-photo'>
        <img src={Cara} alt='Joaquín Gallardo' />
      </div>

      <div className='hero-copy'>
        <h1 className='hero-title'>
          <span className='line'>Tu proyecto,</span>
          <span className='line accent-line'><em>mi proyecto.</em></span>
        </h1>
        <p className='lede'>Cercano en el trato, resolutivo en el código.</p>
        <div className='btns'>
          <a href="#proyectos"><button className='btn'>Proyectos</button></a>
          <a href="#contacto"><button className='btn-light'>Contacto</button></a>
        </div>
      </div>
    </div>
  )
}

export default InitialImg
